import settings from './settings';
import { nanoid } from 'nanoid';
const temp = [
  '',
  'https://avatars.mds.yandex.net/get-pdb/1938902/53d74ac0-9362-49e7-b565-aa5e57b8cdf3/s1200?webp=false',
  ''
];
export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        list.length = 40;
        list.fill({
          id: 1,
          name: 'User',
          avatar: '',
          favorit: false,
          muted: false,
          status: 'Enabled',
          role: 'Admin',
          email: 'asd@ads.ru',
          phone: '+7 888 888 88 88',
          rawEntity: [
            {
              id: nanoid(),
              subheader: 'Groups',
              type: 'tags',
              properties: [
                {
                  id: nanoid(),
                  title: 'Group 1'
                },
                {
                  id: nanoid(),
                  title: 'Group 2'
                },
                {
                  id: nanoid(),
                  title: 'Group 3'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Meta info',
              properties: [
                {
                  id: nanoid(),
                  title: 'Email',
                  subtitle: 'example@mail.con',
                  icon: 'mdi-email',
                  alias: 'userEmail',
                  contextMenu: true
                },
                {
                  id: nanoid(),
                  title: 'Phone',
                  subtitle: '+1 000 000',
                  icon: 'mdi-phone',
                  alias: 'userPhone',
                  contextMenu: true
                },
                {
                  id: nanoid(),
                  title: 'Second ID',
                  subtitle: nanoid(),
                  icon: 'mdi-at',
                  alias: 'userSecondId',
                  contextMenu: true
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Description',
              properties: [
                {
                  id: nanoid(),
                  title: 'User profile comments'
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'UUID',
              properties: [
                {
                  id: nanoid(),
                  title: nanoid()
                }
              ]
            }
          ]
        });
        commit(
          'set',
          list.map((i, n) => {
            return {
              ...i,
              id: i.id + n,
              name: `${i.name} ${n}`,
              avatar: temp[n]
            };
          })
        );
        commit(
          'settings/set',
          Object.keys(list[0]).filter(i => i !== 'avatar' && i !== 'rawEntity')
        );
      }
    }
  }
};
